import React from 'react';
import {
  getVimeoEmbedUrl,
  getVimeoHashFromUrl,
  getVimeoStartTimeFromUrl,
} from '../../utils';
import { VideoWrapper } from '../VideoClickableWrapper';
import { OpenVideoOverlayTrigger } from '../OpenVideoOverlayTrigger';
import { VideoOverlay } from '../VideoOverlay';
import { VimeoPlayer } from './VimeoPlayer';

interface VimeoVideoProps {
  videoUrl: string;
  videoId: number;
  shouldShowOverlay: boolean;
  readonly: boolean;
}

export const VimeoVideo = ({
  videoUrl,
  videoId,
  shouldShowOverlay,
  readonly,
}: VimeoVideoProps) => {
  const videoHash = getVimeoHashFromUrl(videoUrl);
  const videoEmbedUrl = getVimeoEmbedUrl(videoId, videoHash);

  if (!shouldShowOverlay) {
    return (
      <iframe
        src={videoEmbedUrl}
        width="100%"
        height="100%"
        data-testid="vimeo-preview-iframe"
        allow="picture-in-picture"
      />
    );
  }

  if (readonly) {
    return (
      <VideoWrapper>
        <iframe
          src={videoEmbedUrl}
          width="100%"
          height="100%"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </VideoWrapper>
    );
  }

  return (
    <>
      <VideoWrapper>
        <OpenVideoOverlayTrigger />
        <iframe
          src={videoEmbedUrl}
          width="100%"
          height="100%"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </VideoWrapper>
      <VideoOverlay>
        <VimeoPlayer
          embedUrl={videoEmbedUrl}
          startTime={getVimeoStartTimeFromUrl(videoUrl)}
        />
      </VideoOverlay>
    </>
  );
};
